export const AUTH_PROVIDER_BUTTON_STYLE_OVERRIDES = {
  flexBasis: "50%",
  paddingY: "12px",
  "&:hover": { paddingY: "11px" },
  boxShadow: "0px 1px 16px 0px #231F380A",
  "& .provider-button__label": {
    fontWeight: 500,
  },
};
